import styled, { css } from 'styled-components';

export const Table = styled.table`
  user-select: none;
  font-family: Nunito, sans-serif;
  font-size: 16px;
  border-radius: 5px;
  border-collapse: collapse;
  left: 50px;
  right: 50px;
  width: 95%;
  max-width: 100%;
  white-space: nowrap;
  position: absolute;
  top: 220px;
  table-layout: fixed;

  .sort-button {
    background-color: transparent;
    border: none;
    padding: 5px 10px;
    margin: 0;
    line-height: 1;
    font-size: 15px;
    color: var(--color-neutral-blank);
    cursor: pointer;
    transition: transform 0.05s ease-out;
  }

  .sort-reverse {
    transform: rotate(180deg);
  }
`;

export const Thead = styled.thead`
  color: var(--color-neutral-blank);
  background: var(--color-neutral-darker);
`;

export const Tbody = styled.tbody`
  width: 100%;
  color: var(--color-neutral-blank);
  background-color: var(--color-neutral-darker-alt);
  border: 2px solid var(--color-neutral-lighter);
`;

export const Td = styled.td<{
  backgroundColor?: string;
  color?: string;
  fontWeight?: string;
}>`
  font-family: Nunito, sans-serif;
  border-radius: 4px;
  text-align: center;
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
  color: var(--color-neutral-blank);
  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
  ${({ fontWeight }) =>
    fontWeight &&
    css`
      font-weight: ${fontWeight};
    `}
`;

export const Tr = styled.tr`
  width: 100%;
  border: 4px solid var(--color-neutral-darker);
  border-radius: 4px;
  :hover Td {
    background-color: var(--color-neutral-dark);
  }
`;

export const Th = styled.th`
  font-family: Nunito, sans-serif;
  border-radius: 4px;
  text-align: center;
  padding: 8px;
  font-size: 14px;
  background: var(--color-neutral-darker);
  cursor: default;
  color: var(--color-neutral-blank);
`;

export const Line = styled.div`
  width: 100%;
  height: 4px;
  background-color: var(--color-neutral-dark);
`;
